<template>
    <Transition :name="props.transition" appear @after-leave="afterLeave">
        <div
            v-if="visible"
            class="alert"
            :class="props.class"
            @mouseenter="pauseTimer"
            @mouseleave="startTimer"
        >
            <p class="message">
                <i class="material-icons" v-if="props.class == 'danger-alert'">error_outlined</i>&nbsp;
                <i class="material-icons" v-if="props.class == 'success-alert'">check</i>&nbsp;
                <slot></slot>
            </p>
            <button @click="close"><i class="material-icons">close</i></button>
        </div>
    </Transition>
</template>

<script setup>
import { onBeforeMount, onMounted, Transition, ref } from 'vue';

const visible = ref(true)
let timer     = null

const props = defineProps({
    message: String,
    class: String,
    transition: {
        type: String, default: 'slide-fade'
    }
})

const emits = defineEmits(['closed'])

const startTimer = () => {
    if (timer) clearTimeout(timer)
    timer = setTimeout(() => close(), 3000)
}

const pauseTimer = () => {
    if (timer) clearTimeout(timer)
}

const close = () => {
    visible.value = false
}
const afterLeave = () => {
    emits('closed')
}

onMounted(() => startTimer())
onBeforeMount(() => clearTimeout(timer))
</script>

<style lang="scss" scoped>
.alert {
    display: flex;
    align-items: center;
    max-width: max-content;
    position: relative;
    padding: .75rem 1rem;
    border-radius: 6px;

    .message {
        display: flex;
        align-items: center;
        overflow-wrap: anywhere;
    }

    button {
        background-color: transparent;
        border: none;
        color: inherit;
        margin-left: 1rem;

        padding: 0;

        cursor: pointer;
    }

    p {
        margin: 0;
    }

    max-width: 90%;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all .2s ease-out;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
    opacity: 0;
    transform: translateX(20px);
}

.slide-fade-vertical-enter-active,
.slide-fade-vertical-leave-active {
    transition: all .2s ease-out;
}

.slide-fade-vertical-enter-from,
.slide-fade-vertical-leave-to {
    opacity: 0;
    transform: translateY(-20px);
}

.bounce-enter-active {
    animation: bounce-in 0.5s;
}
.bounce-leave-active {
    animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
    0% {
        transform: scale(0);
    }
    50% {
        transform: scale(1.25);
    }
    100% {
        transform: scale(1);
    }
}
</style>